/* eslint-disable */
import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import MisconceptionCards from '../../components/MisconceptionCards';
import HighlightedCardsGrid from '../../components/HighlightedCardsGrid';
import NumberedStepsIllustration from '../../components/NumberedStepsIllustration';
import { CTIS_HCG_ICONS, MC_Section2_ICONS } from './iconMap';
import stepBg1 from '../../../../../../assets/student-training/pyde/step-bg1.png';
import stepBg2 from '../../../../../../assets/student-training/pyde/step-bg2.png';
import stepBg3 from '../../../../../../assets/student-training/pyde/step-bg3.png';
import stepBg4 from '../../../../../../assets/student-training/pyde/step-bg4.png';
import stepBg5 from '../../../../../../assets/student-training/pyde/step-bg5.png';
import stepIllustration from '../../../../../../assets/student-training/ctis/img2.png';
interface ISection1Props {
  settings: any;
}

const STEP_CARD_BACKGROUNDS = [stepBg1, stepBg2, stepBg3, stepBg4, stepBg5];
const Section2: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );

  const handleMisconceptionCardsComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-cits-section2-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  const handleNumberedStepsComplete = useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-cits-section2-2'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-2">
      <MisconceptionCards
        title={paragraphsSettings?.title}
        subTitle={paragraphsSettings?.misconceptionCardsTitle}
        items={paragraphsSettings?.misconceptionCardsList}
        tips={paragraphsSettings?.misconceptionCardsTips}
        icons={MC_Section2_ICONS}
        id="student-training-cits-section2-1"
        onComplete={handleMisconceptionCardsComplete}
      />
      <HighlightedCardsGrid
        subTitle={paragraphsSettings?.HCGTitle}
        description={paragraphsSettings?.HCGDesc}
        items={paragraphsSettings?.HCGItems.map((item: any, index: number) => ({
          ...item,
          icon: CTIS_HCG_ICONS[index](false),
        }))}
      />
      <div style={{ margin: '10rem 0 8rem 0' }}>
        <NumberedStepsIllustration
          mainTitle={paragraphsSettings?.NSITitle}
          description={paragraphsSettings?.NSIDesc}
          cardBackgrounds={STEP_CARD_BACKGROUNDS}
          illustration={<img src={stepIllustration} alt="" />}
          items={paragraphsSettings?.NSIItems}
          onComplete={handleNumberedStepsComplete}
        />
      </div>
    </div>
  );
};

export default Section2;
